import { Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import {
  Configuration,
  CONFIGURATION_TYPE,
  ProcureUser,
  ProcureVendor,
} from 'vendor-marketplace-shared-library';
import PrimaryButton from '../../../components/common/styled-mui-overrides/PrimaryButton';
import React, { Dispatch, SetStateAction } from 'react';
import { WatchersSelection } from '../../../components/work-orders/WatchersSelection';
import { ConciergeEnabledWorkOrderModule } from '../../../components/work-orders/ConciergeEnabledWorkOrderModule';
import { useNavigate } from 'react-router-dom';
import SecondaryButton from '../../../components/common/styled-mui-overrides/SecondaryButton';
import { UpdateWorkOrderFormData } from '../CreateWorkOrderFormPage';
import { getConfigurationValue } from '../../../utilities/helpers';
import useConfigurations from '../../../hooks/useConfigurations';

type CreateWorkOrderWhoProps = {
  workOrderId: string;
  users: ProcureUser[];
  workOrderWatcherIds: string[];
  vendors: ProcureVendor[];
  setWorkOrderWatcherIds: (watchers: string[]) => void;
  formData: Partial<UpdateWorkOrderFormData>;
  setFormData: (data: Partial<UpdateWorkOrderFormData>) => void;
  maxBudget: number;
  setMaxBudget: Dispatch<SetStateAction<number>>;
  conciergeEnabled: boolean;
  setConciergeEnabled: Dispatch<SetStateAction<boolean>>;
  onSubmit: () => void;
};

export default function CreateWorkOrderWho(props: CreateWorkOrderWhoProps) {
  const navigate = useNavigate();
  const { configurationsQuery } = useConfigurations();

  const userConciergeFeatureFrontendEnabledConfiguration =
    configurationsQuery?.data?.getConfigurations?.find(
      (configuration: Configuration) =>
        configuration.name === CONFIGURATION_TYPE.CONCIERGE_FEATURE_FRONTEND_IS_ENABLED,
    );

  const isUserConciergeFeatureFrontendEnabled = getConfigurationValue(
    userConciergeFeatureFrontendEnabledConfiguration,
  );

  const userConciergeVendorsIsEnabledConfiguration =
    configurationsQuery?.data?.getConfigurations?.find(
      (configuration: Configuration) =>
        configuration.name === CONFIGURATION_TYPE.CONCIERGE_VENDORS_IS_ENABLED,
    );

  const isUserConciergeVendorsEnabled = getConfigurationValue(
    userConciergeVendorsIsEnabledConfiguration,
  );

  const userNonWarrantyWorkOrderCreationIsEnabledConfiguration =
    configurationsQuery?.data?.getConfigurations?.find(
      (configuration: Configuration) =>
        configuration.name === CONFIGURATION_TYPE.NON_WARRANTY_WORK_ORDER_CREATION_IS_ENABLED,
    );

  const isUserNonWarrantyWorkOrderCreationIsEnabled = getConfigurationValue(
    userNonWarrantyWorkOrderCreationIsEnabledConfiguration,
  );

  return (
    <Grid container sx={styles.mainContainer}>
      <Grid item xs={0} md={3}></Grid>
      <Grid item container xs={12} md={6} sx={styles.centerContainer} spacing={2}>
        <Grid item xs={12}>
          <InputLabel>Assigned User</InputLabel>

          <Select
            name={'assignedUserId'}
            fullWidth
            value={props.formData.assignedUserId}
            onChange={e => props.setFormData({ ...props.formData, assignedUserId: e.target.value })}
          >
            {props.users.map((user: ProcureUser) => (
              <MenuItem key={user.id} value={user.id}>
                {user.fullName}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        {isUserConciergeFeatureFrontendEnabled && (
          <Grid item>
            <ConciergeEnabledWorkOrderModule
              conciergeEnabled={props.conciergeEnabled}
              setConciergeEnabled={props.setConciergeEnabled}
              maxBudget={props.maxBudget}
              setMaxBudget={props.setMaxBudget}
            />
          </Grid>
        )}

        {props.vendors.length > 0 && isUserConciergeVendorsEnabled && (
          <Grid item xs={12}>
            <InputLabel>Assigned Vendor</InputLabel>
            <Select
              name={'procureVendorId'}
              placeholder={'Select Vendor'}
              fullWidth
              value={props.formData.procureVendorId}
              onChange={e =>
                props.setFormData({ ...props.formData, procureVendorId: e.target.value })
              }
            >
              {props.vendors.map((vendor: ProcureVendor) => (
                <MenuItem key={vendor.id} value={vendor.id}>
                  {vendor.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        )}
        {/*Update Watchers*/}
        <Grid container item xs={12} sx={styles.watcherContainer}>
          <Grid item>
            <Typography>Keep people updated:</Typography>
          </Grid>
          <Grid item>
            <WatchersSelection
              watcherIds={props.workOrderWatcherIds.map(id => id)}
              setWatcherIds={props.setWorkOrderWatcherIds}
              users={props.users}
              onSave={() =>
                props.setFormData({
                  ...props.formData,
                  workOrderWatcherUserIds: props.workOrderWatcherIds.map(id => id),
                })
              }
            />
          </Grid>
        </Grid>
        <Grid item>
          <SecondaryButton
            onClick={() => navigate(`/create-work-order/${props.workOrderId}/?step=2`)}
          >
            Back
          </SecondaryButton>
        </Grid>

        <Grid item>
          <PrimaryButton
            onClick={() => {
              props.onSubmit();
              isUserNonWarrantyWorkOrderCreationIsEnabled
                ? navigate(`/create-work-order/${props.workOrderId}/?step=4`)
                : navigate('/');
            }}
          >
            Next
          </PrimaryButton>
        </Grid>
      </Grid>
      <Grid item xs={0} md={3}></Grid>
    </Grid>
  );
}

const styles = {
  mainContainer: {
    justifyContent: 'center',
    paddingTop: 4,
  },
  centerContainer: {
    justifyContent: 'center',
  },
  watcherContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    columnGap: 2,
  },
};
